import React from 'react';

type IconCaretThinProps = {
    className?: string;
};

export function IconCaretThin(props: IconCaretThinProps) {
    const { className = '' } = props;
    return (
        <svg
            className={`${className} -rotate-90`}
            width="24"
            height="24"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_2489_1820"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="40"
                height="40"
            >
                <rect width="40" height="40" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2489_1820)">
                <path d="M20 26.371L8 14.371L9.37105 13L20 23.629L30.629 13L32 14.371L20 26.371Z" fill="#000000" />
            </g>
        </svg>
    );
}

export default IconCaretThin;
